import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React from 'react';
import { Image, ScrollView, View } from 'react-native';
import MenuListSection from './components/MenuListSection';
import MyProfileSection from './components/MyProfileSection';
const MenuScreen = ({}) => {
    return (_jsxs(ScrollView, { className: "bg-white", children: [_jsx(Image, { source: require('@/assets/img/bg_mypage_header.jpg'), className: "w-full h-[220px]" }), _jsx(MyProfileSection, {}), _jsx(View, { className: "h-[10px] w-full bg-gray-10" }), _jsx(MenuListSection, {})] }));
};
export default MenuScreen;
